console.log('Custom search JS loaded!');

document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.querySelector('.announcement__bar-section');
  
  if (!announcementBar) return;
  
  const countrySelector = announcementBar.querySelector('[data-disclosure-country]');
  if (!countrySelector) return;
  
  const disclosureList = countrySelector.querySelector('.disclosure-list');
  const countryList = countrySelector.querySelector('.disclosure--list_ul');
  
  if (!disclosureList || !countryList) return;
  
  // Increase the dropdown height
  disclosureList.style.maxHeight = '400px';
  disclosureList.style.overflowY = 'auto';
  disclosureList.style.width = '280px'; // Optional: make it wider
  
  if (disclosureList.querySelector('.country-search-wrapper')) {
    console.log('Search already exists, skipping');
    return;
  }
  
  console.log('Adding search bar...');
  
  // Create search wrapper
  const searchWrapper = document.createElement('div');
  searchWrapper.className = 'country-search-wrapper';
  searchWrapper.style.cssText = `
    padding: 10px 12px;
    border-bottom: 1px solid #e5e5e5;
    background: white;
    position: sticky;
    top: 0;
    z-index: 3;
  `;
  
  // Create search input
  const searchInput = document.createElement('input');
  searchInput.type = 'text';
  searchInput.placeholder = ' Search countries...';
  searchInput.className = 'country-search-input';
  searchInput.style.cssText = `
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 13px;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.2s;
  `;
  
  searchInput.addEventListener('focus', function() {
    this.style.borderColor = '#000';
  });
  
  searchInput.addEventListener('blur', function() {
    this.style.borderColor = '#ddd';
  });
  
  searchWrapper.appendChild(searchInput);
  
  // Insert before the country list
  disclosureList.insertBefore(searchWrapper, countryList);
  console.log('Search bar added successfully!');
  
  // Search functionality
  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.toLowerCase().trim();
    const items = countryList.querySelectorAll('.disclosure-list__item');
    
    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      const isVisible = searchTerm === '' || text.includes(searchTerm);
      item.style.display = isVisible ? '' : 'none';
    });
  });
  
  // Reset search when dropdown closes
  const toggle = countrySelector.querySelector('.disclosure__toggle');
  if (toggle) {
    document.addEventListener('click', function(e) {
      if (!countrySelector.contains(e.target) && !toggle.contains(e.target)) {
        searchInput.value = '';
        countryList.querySelectorAll('.disclosure-list__item').forEach(item => {
          item.style.display = '';
        });
      }
    });
  }
  
  // Auto-focus when dropdown opens
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          setTimeout(() => {
            searchInput.focus();
            // Also scroll to top of list
            disclosureList.scrollTop = 0;
          }, 100);
        }
      }
    });
  });
  
  if (toggle) {
    observer.observe(toggle, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }
});
// Fallback: Add currency code to product page prices
function addCurrencyToProductPrice() {
  const currencyCode = document.querySelector('[name="country_code"]')?.value || '';
  if (!currencyCode) return;
  
  // Target price items on product page
  const priceItems = document.querySelectorAll(
    '.product__section--price .price-item, ' +
    '.product__section-details .price-item'
  );
  
  priceItems.forEach(el => {
    // Skip if already has currency
    if (el.querySelector('.currency-code-product')) return;
    
    // Skip sale badge elements
    if (el.closest('.product__section--savings')) return;
    
    // Only add to price items that don't already have currency text
    if (!el.textContent.includes(currencyCode)) {
      const codeSpan = document.createElement('span');
      codeSpan.className = 'currency-code-product';
      codeSpan.textContent = ' ' + currencyCode;
      codeSpan.style.cssText = `
        font-size: 0.7em;
        font-weight: 400;
        opacity: 0.6;
        margin-left: 2px;
      `;
      el.appendChild(codeSpan);
    }
  });
}

// Run when needed
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(addCurrencyToProductPrice, 500);
});

// Run when variant changes
document.addEventListener('change', function(e) {
  if (e.target.closest('.product-form__input input, .single-option-selector, .variant-selector')) {
    setTimeout(addCurrencyToProductPrice, 500);
  }
});

// Run when currency changes
document.addEventListener('click', function(e) {
  if (e.target.closest('.disclosure-list__option')) {
    setTimeout(addCurrencyToProductPrice, 1000);
  }
});